<template>
    <div class="container">
        <v-title :breadcrumb="{label: 'Shipping Zones', route: {name: 'shipping-zones'}}">
            Shipping Zones
            <div slot="actions">
                <router-link
                    v-if="$auth.$pages['add-shipping-zone'].isAllowed"
                    :to="{name: 'add-shipping-zone'}"
                    class="btn btn-link">Add Shipping Zone<v-icon class="margin-left-xs" icon="arrow-right"/></router-link>
            </div>
        </v-title>
        <v-form-tile>
            <h2 slot="title">Zones &amp; Rates</h2>
            <p slot="description" class="text-muted">Use shipping zones to choose the regions that you ship to. Define
                your shipping rates for each zone that will show up during checkout.</p>
            <div slot="content" class="tile position-relative" v-if="hasShippingZones">
                <v-inline-loader v-if="isShippingZoneLoading"/>
                <shipping-zones-list
                    v-for="(shippingZone, index) in shippingZones"
                    :key="index"
                    :shipping-zone="shippingZone"
                    @delete="deleteShippingZone"
                />
            </div>
            <div slot="content" class="tile position-relative" v-else>
                <v-no-content>
                    <span slot="title">It seems that you have no shipping zones</span>
                    <span slot="actions">
                        <router-link
                            v-if="$auth.$pages['add-shipping-zone'].isAllowed"
                            :to="{name: 'add-shipping-zone'}"
                            class="btn btn-link">Add Shipping Zone<v-icon class="margin-left-xs" icon="arrow-right"/></router-link>
                    </span>
                </v-no-content>
            </div>
        </v-form-tile>
    </div>
</template>

<script>
    import vTitle from '@/components/v-title';
    import {
        vIcon, vFormTile,
    } from '@/components/form';
    import ShippingZoneModel from '@/common/models/shipping-zone-model';
    import FormLoaderMixin from '@/mixins/form-loader-mixin';
    import shippingZonesList from './components/shipping-zones-list';
    import vInlineLoader from '@/components/v-inline-loader';
    import vNoContent from '@/components/v-no-content';

    export default {
        name: 'shipping-zones',
        mixins: [FormLoaderMixin],
        components: {
            vTitle,
            vIcon,
            vFormTile,
            shippingZonesList,
            vInlineLoader,
            vNoContent,
        },
        data() {
            return {
                shippingZones: [],
                isShippingZoneLoading: false,
            };
        },
        computed: {
            isDataRequired() {
                return !this.isDataReady;
            },
            hasShippingZones() {
                return this.shippingZones.length;
            },
        },
        methods: {
            async deleteShippingZone(id) {
                try {
                    this.isShippingZoneLoading = true;
                    await this.$api(({shippingZones}) => shippingZones.delete({id}));
                    await this.fetchData();
                    this.$toast.positive(`Shipping zone successfully deleted`);
                } catch (error) {
                    this.$toast.fromError(error, `Shipping zone data could not be deleted, please contact support`);
                } finally {
                    this.isShippingZoneLoading = false;
                }
            },
            async fetchData() {
                try {
                    const shippingZoneItems = await this.$api(({shippingZones}) => shippingZones.getAll());
                    this.shippingZones = shippingZoneItems.items.map(item => new ShippingZoneModel(item.fields))
                        .sort(item => (item.isDefault ? -1 : 1));
                } catch (error) {
                    this.$toast.fromError(error, 'Something went wrong, please contact support');
                }
            },
        },
    };
</script>
